import React from "react";
import { navigate } from "@reach/router";
import { TabHeader } from "components/TabHeader";
import { Flex, Spinner, Tooltip } from "@chakra-ui/react";
import { Button } from "components/RFQ/Button";
import MenuBarComp from "./MenuBarComp";
import { BackButton } from "components/RFQ/BackButton";

import NoBorderButton from "components/RFQ/NoBorderButton/NoBorderButton";
import { cn } from "utils/helpers";
import { SkeletonBase } from "components/Skeleton";

import {
	ADDENDUMS,
	STATUS_ACCEPTED,
	STATUS_DECLINE,
	STATUS_IN_PROGRESS,
	STATUS_INVITED,
} from "utils/constants";

const deadlineTooltip =
	"Submission deadline has passed. You can no longer submit a response.";
const tooltipProps = {
	hasArrow: true,
	shouldWrapChildren: true,
	bg: "gray",
	color: "white",
};

const ButtonActions = ({
	isBottom,
	isLoading,
	loadingSave,
	setShowDialog,
	currentTab,
	continueTab,
	saveHandler,
	isRFxClosed,
	submitHandler,
	submissionStatus,
	isFileUploadInProgress,
	validForm,
	hasDeadlinePassed,
}) => {
	const isInvited = submissionStatus === STATUS_INVITED;
	const isAccepted =
		submissionStatus === STATUS_ACCEPTED ||
		submissionStatus === STATUS_IN_PROGRESS;
	const isDeclined = submissionStatus === STATUS_DECLINE;

	const submissionTooltip = hasDeadlinePassed
		? deadlineTooltip
		: isLoading
			? "Saving your response, please wait..."
			: !validForm
				? "Please fill all required fields before submitting."
				: "Submit your response to this RFx";

	return isLoading ? (
		<div className="mt-4 flex justify-end gap-3">
			<SkeletonBase
				width="128px"
				height="46"
			/>
			<SkeletonBase
				width="128px"
				height="46"
			/>
		</div>
	) : !isDeclined && !isRFxClosed ? (
		<TabHeader
			noDivider={true}
			icon={
				!isBottom && <BackButton handleBackButtonClick={() => navigate("..")} />
			}
		>
			{isAccepted ? (
				<Flex
					gap={3}
					className={cn("items-center", isBottom && "py-8")}
				>
					{loadingSave ? (
						<Spinner />
					) : (
						!hasDeadlinePassed && (
							<Tooltip
								{...tooltipProps}
								label={
									isFileUploadInProgress
										? "File upload in progress, please wait..."
										: "Save all changes"
								}
							>
								<NoBorderButton
									onClick={() => saveHandler()} //
									text="Save"
									className="bg-white font-roboto text-[14px] font-medium text-tertiary-600"
									disabled={isFileUploadInProgress || hasDeadlinePassed}
								/>
							</Tooltip>
						)
					)}
					{currentTab !== ADDENDUMS && (
						<Tooltip
							{...tooltipProps}
							label={
								hasDeadlinePassed ? deadlineTooltip : "Continue to next tab"
							}
						>
							<Button
								type="button"
								btntype="secondary"
								disabled={
									loadingSave || isFileUploadInProgress || hasDeadlinePassed
								}
								onClick={() => {
									continueTab();
								}} //
								data-testid="continue-button"
							>
								Continue
							</Button>
						</Tooltip>
					)}
					<Tooltip
						{...tooltipProps}
						label={submissionTooltip}
					>
						<Button
							type="button"
							onClick={() => {
								submitHandler(currentTab);
							}}
							disabled={loadingSave || !validForm || hasDeadlinePassed}
							data-testid="submit-button"
						>
							Submit Response
						</Button>
					</Tooltip>
				</Flex>
			) : (
				isInvited && (
					<div className="align-start inline-flex justify-end gap-2">
						{!isBottom && (
							<span className="max-w-[350px] text-sm">
								This is a Preview only, we can notify the Client and let them
								know if you Accept or Decline the Invitation.
							</span>
						)}
						<MenuBarComp
							hasDeadlinePassed={hasDeadlinePassed}
							setShowDialog={setShowDialog}
							className={isBottom ? "py-8" : "self-center"}
							tooltipProps={tooltipProps}
						></MenuBarComp>
					</div>
				)
			)}
		</TabHeader>
	) : (
		!isBottom && (
			<TabHeader
				noDivider={true}
				icon={<BackButton handleBackButtonClick={() => navigate("..")} />}
			/>
		)
	);
};

export default ButtonActions;
